// Modules
import { hashSync } from "bcryptjs";

/**
 * Generates a hashed token.
 *
 * @returns the token
 */
export function generateToken() {
    const tokenString = `${process.env.REACT_APP_SECRET_KEY}_${new Date().toISOString().split("T")[0]}`;

    const token = hashSync(tokenString, 12);

    return token;
}
